<template>
    <div id="live"  :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto">
        <div class="liveframe">
            <div class="liveframe-title">
                <img :src="imgPath+'livetitle.png'" alt="">
            </div>
            <div class="liveframe-content">
                <div class="livelist" v-for="(item,key) in imglist" :key="key">
                    <img :src="imgPath+item.img" alt=""  @click="setimages(key)">
                    <p>{{item.text}}</p>
                </div>
            </div>
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath,
            imglist:[
                {
                    id:'1',
                    img:'liveimg/1.jpg',
                    text:'2021年3月31日，顺德国际营商环境推介会暨寻味顺德——世界美食之都全国路演活动在上海黄浦江畔举行。'
                },{
                    id:'2',
                    img:'liveimg/2.jpg',
                    text:'活动吸引来自各行业、各领域的企业代表参加'
                },{
                    id:'3',
                    img:'liveimg/3.jpg',
                    text:'顺德区经济促进局副局长葛爱霞主持会议'
                },{
                    id:'4',
                    img:'liveimg/4.jpg',
                    text:'顺德区经济促进局局长吴显强推介顺德'
                },{
                    id:'5',
                    img:'liveimg/5.jpg',
                    text:'顺德区委副书记、区长王勇出席活动，并热情洋溢为顺德营商环境打Call'
                },{
                    id:'6',
                    img:'liveimg/6.jpg',
                    text:'与会企业代表 认真聆听顺德的“过去、现在和未来”'
                },{
                    id:'7',
                    img:'liveimg/7.jpg',
                    text:'格兰仕集团代表现场发布项目合作需求'
                },{
                    id:'8',
                    img:'liveimg/8.jpg',
                    text:'千玺机器人集团线上发布项目合作需求'
                },{
                    id:'9',
                    img:'liveimg/9.jpg',
                    text:'广东跃昉科技代表现场动情分享企业创立初期故事，并为顺德政务服务点赞'
                },{
                    id:'10',
                    img:'liveimg/10.jpg',
                    text:'顺德日资企业代表作发展经验分享，为顺德优质营商环境点赞'
                },{
                    id:'11',
                    img:'liveimg/11.jpg',
                    text:'现场座无虚席，齐聚一堂共觅商机'
                },{
                    id:'12',
                    img:'liveimg/12.jpg',
                    text:'现场企业代表表达和顺德的合作需求'
                },{
                    id:'13',
                    img:'liveimg/13.jpg',
                    text:'与会企业代表表达和顺德的合作需求'
                }
            ]
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        },
        setimages(val){
            var _this = this;
            ImagePreview({
            images: [
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/1.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/2.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/3.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/4.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/5.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/6.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/7.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/8.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/9.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/10.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/11.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/12.jpg',
                'https://t.shundecity.com/shzstjh2021/Home/View/Index/images/liveimg/13.jpg',
            ],
            startPosition: val,
            onClose() {
                // do something
            },
            });
        }
    },
}
</script>
<style lang="less" scoped>
@base:46.875rem;
#live{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
    position: relative;
    .liveframe{
        width: 90%;
        height: 80%;
        padding: 70/@base 20/@base 20/@base;
        position: absolute;
        top:5%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-shadow:  0 0 20px 10px rgba(255, 255, 255, 0.3);
        .liveframe-title{
            width:334/@base;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-30%);
        }
        .liveframe-content{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            .livelist{
                width: 100%;
                padding: 10/@base;
                p{
                    font-size: 0.64rem;
                    line-height: 1.5;
                    text-align: center;
                    width: 100%;
                    padding: 10/@base;
                }
                
            }
        }
    }
    .back{
        position: absolute;
        width: 113/@base;
        left: 50%;
        top: 88%;
        transform: translateX(-50%);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Live.vue